import { createStyledContext } from "@tamagui/core";
const {
  Provider: TabsProvider,
  useStyledContext: useTabsContext
} = createStyledContext();
export { TabsProvider, useTabsContext };
//# sourceMappingURL=StyledContext.mjs.map
